import { render, staticRenderFns } from "./CustomerCard.vue?vue&type=template&id=493993c0"
import script from "./CustomerCard.vue?vue&type=script&lang=js"
export * from "./CustomerCard.vue?vue&type=script&lang=js"
import style0 from "./CustomerCard.vue?vue&type=style&index=0&id=493993c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports